module.exports = __webpack_public_path__ + "img/ToyFaces_Colored_BG_61.cb50826c.jpg";